import React, { Component } from 'react';
import "./portfolio.css";
import NothingToSeeHere from './move-along-nothing-to-see-here.jpg';

export default class Portfolio extends Component {
  render() {
    return (
        <img class="nothingToSeeHere" src={NothingToSeeHere} alt="Nothing to see here"/>
      );
  }
}